module.exports = __webpack_public_path__ + "static/media/bulletpoints-studio-logo.caa8f9a4.svg";